import { Injectable } from '@angular/core';
import { BlocksIcon, BuildingIcon, CableIcon, FolderClosedIcon, UserIcon, UsersIcon } from 'lucide-angular';
import { NavRoute } from '../interfaces/nav-route';
import { settingsRoutes } from '../pages/settings/common/settings.constants';
import { PosthogService } from './posthog.service';
import { Constants } from '../helpers';

@Injectable({
	providedIn: 'root',
})
export class SettingsService {
	constructor(private posthogService: PosthogService) {}

	public integrations = (): boolean => {
		return this.posthogService.isEnabled('xero');
	};

	getRoutes(): NavRoute[] {
		const settings = Constants.ROUTE_LINKS.admin;
		return [
			{ name: 'Account', route: `/${settings}/${settingsRoutes.accountDetails}`, icon: UserIcon },
			{ name: 'Companies', route: `/${settings}/${settingsRoutes.companies}`, icon: BuildingIcon },
			{ name: 'Divisions', route: `/${settings}/${settingsRoutes.divisions}`, icon: BlocksIcon },
			{ name: 'Users', route: `/${settings}/${settingsRoutes.users}`, icon: UsersIcon },
			{ name: 'Project Defaults', route: `/${settings}/${settingsRoutes.projectDefaults}`, icon: FolderClosedIcon },
			{ name: 'Integrations', route: `/${settings}/${settingsRoutes.integrations}`, icon: CableIcon, disabled: !this.integrations() },
		];
	}
}
